import React from 'react'
import { MenuItem, Typography } from '@mui/material'
import PropTypes from 'prop-types'
import { KeyboardArrowDownRounded } from '@mui/icons-material'
import HHFormAutocompleteField from 'components/form-fields/v5/HHFormAutocompleteField'

/**
 * Custom SingleSelect Autocomplete Field for Configured Services filters
 * This is a specialized version of HHFormAutocompleteField for single selection
 */
const FilterSingleSelectField = ({
  name,
  control,
  disabled = false,
  label = undefined,
  placeholder = '',
  size = 'medium',
  variant = 'outlined',
  rules = undefined,
  required = false,
  fullWidth = false,
  options,
  noOptionsText,
  openOnFocus = false,
  loading = false,
  getOptionLabel = x => x,
  isOptionEqualToValue = (option, value) => option === value,
  onChangeMiddleware = (onChange, item) => {
    onChange(item)
  },
  debug = false,
  ...rest
}) => {
  return (
    <HHFormAutocompleteField
      sx={{
        '.MuiAutocomplete-inputRoot': {
          flexWrap: 'wrap',
        },
      }}
      TextFieldProps={{
        defaultSize: true,
      }}
      slotProps={{}}
      debug={debug}
      isOptionEqualToValue={isOptionEqualToValue}
      name={name}
      control={control}
      disabled={disabled}
      label={label}
      placeholder={placeholder}
      size={size}
      variant={variant}
      rules={rules}
      required={required}
      fullWidth={fullWidth}
      options={options}
      popupIcon={<KeyboardArrowDownRounded />}
      noOptionsText={noOptionsText}
      onChangeMiddleware={onChangeMiddleware}
      multiple={false}
      renderOption={(props, option) => {
        return (
          <MenuItem key={`${name}-option-${getOptionLabel(option)}`} sx={{ paddingX: 0.5 }} {...props}>
            <Typography noWrap>{getOptionLabel(option)}</Typography>
          </MenuItem>
        )
      }}
      getOptionLabel={getOptionLabel}
      openOnFocus={openOnFocus}
      loading={loading}
      {...rest}
    />
  )
}

FilterSingleSelectField.propTypes = {
  name: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium']),
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard']),
  rules: PropTypes.object,
  required: PropTypes.bool,
  fullWidth: PropTypes.bool,
  options: PropTypes.array.isRequired,
  noOptionsText: PropTypes.node,
  getOptionLabel: PropTypes.func,
  openOnFocus: PropTypes.bool,
  loading: PropTypes.bool,
  isOptionEqualToValue: PropTypes.func,
  onChangeMiddleware: PropTypes.func,
  debug: PropTypes.bool,
}

export default FilterSingleSelectField
